import { LeadState } from '../assistant';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_LEAD_STATE = 'LEAD_STATE_';

export const LeadStateTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_LEAD_STATE}${LeadState.COLD}`]: 'Froid',
    [`${TRANSLATE_KEY_LEAD_STATE}${LeadState.WARM}`]: 'Tiède',
    [`${TRANSLATE_KEY_LEAD_STATE}${LeadState.QUALIFIED}`]: 'Qualifié',
    [`${TRANSLATE_KEY_LEAD_STATE}${LeadState.SUSPENS}`]: 'En suspens',
    [`${TRANSLATE_KEY_LEAD_STATE}${LeadState.LOST}`]: 'Disqualifié',
    [`${TRANSLATE_KEY_LEAD_STATE}${LeadState.ONBOARDING}`]: 'Onboarding',
    [`${TRANSLATE_KEY_LEAD_STATE}${LeadState.TRIAL}`]: 'Essai',
    [`${TRANSLATE_KEY_LEAD_STATE}${LeadState.PAID}`]: 'Payé',
    [`${TRANSLATE_KEY_LEAD_STATE}${LeadState.ACTIVE}`]: 'Actif',
    [`${TRANSLATE_KEY_LEAD_STATE}${LeadState.AT_RISK}`]: 'À risque',
    [`${TRANSLATE_KEY_LEAD_STATE}${LeadState.CHURNED}`]: 'Perdu',
    [`${TRANSLATE_KEY_LEAD_STATE}${LeadState.AMBASSADEUR}`]: 'Ambassadeur',
    [`${TRANSLATE_KEY_LEAD_STATE}${LeadState.DISTANT_PROJECT}`]: 'Projet lointain',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(LeadState, LeadStateTranslation, TRANSLATE_KEY_LEAD_STATE, true);
